import { CommonModule } from '@angular/common';
import { ModuleWithProviders, NgModule } from '@angular/core';
import { SystemEventsService } from '@uzurv/core';
import { UzurvRestConfiguration, UZURV_REST_CONFIGURATION } from '../interfaces';
import { AuthTokenService } from './auth-token/auth-token.service';

@NgModule({
  imports: [CommonModule],
  providers: [AuthTokenService, SystemEventsService]
})
export class UzurvRestApiModule {
  static forRoot(uzurvRestConfiguration: UzurvRestConfiguration): ModuleWithProviders<UzurvRestApiModule> {
    return {
      ngModule: UzurvRestApiModule,
      providers: [
        {
          provide: UZURV_REST_CONFIGURATION,
          useValue: uzurvRestConfiguration
        }
      ]
    };
  }
}
